import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { push } from 'connected-react-router';

export const editEntity: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { regionApi },
) =>
  action$.pipe(
    ofType(actions.EDIT_ENTITY_ACTIONS.REQUESTED),
    switchMap(({ payload: { id, value, type } }) =>
      regionApi.editEntity(id, value, type).pipe(
        switchMap(() => of(actions.editEntitySucceeded(), push('/countries'))),
        catchError(error => of(actions.editStoreFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/epics/editEntity.ts